import TomSelect from 'tom-select'
//Form Select Field
document.querySelectorAll('.select').forEach((el) => {
  const select = el as HTMLSelectElement
  let settings = {
    create: false
  }
  new TomSelect(select, settings)
})
